'use client'

import { useNavigate } from 'react-router-dom'
import {
    MdReceipt,
    MdDescription,
    MdWarning,
    MdVerified,
    MdInventory,
    MdAttachMoney,
    MdArrowForward,
    MdTableChart,
} from 'react-icons/md'

interface BillingCard {
    id: string
    name: string
    description: string
    icon: React.ReactNode
    route: string
    color: string
}

export default function BillingPage() {
    const navigate = useNavigate()

    const billingCards: BillingCard[] = [
        {
            id: 'price-tables',
            name: 'Tabelas de Preços',
            description:
                'Gerencie tabelas de preços CBHPM, TUSS, AMB e personalizadas por convênio',
            icon: <MdTableChart className="text-4xl" />,
            route: '/billing/price-tables',
            color: 'from-blue-500 to-blue-600',
        },
        {
            id: 'guides',
            name: 'Guias TISS',
            description:
                'Crie e gerencie guias de consulta, SP/SADT, internação e honorários',
            icon: <MdDescription className="text-4xl" />,
            route: '/billing/guides',
            color: 'from-green-500 to-green-600',
        },
        {
            id: 'glosses',
            name: 'Glosas',
            description:
                'Acompanhe e gerencie glosas com recursos e estatísticas de recuperação',
            icon: <MdWarning className="text-4xl" />,
            route: '/billing/glosses',
            color: 'from-red-500 to-red-600',
        },
        {
            id: 'authorizations',
            name: 'Autorizações',
            description:
                'Solicite e acompanhe autorizações prévias junto aos convênios',
            icon: <MdVerified className="text-4xl" />,
            route: '/billing/authorizations',
            color: 'from-purple-500 to-purple-600',
        },
        {
            id: 'batches',
            name: 'Lotes de Faturamento',
            description:
                'Agrupe guias em lotes para envio e acompanhe retornos dos convênios',
            icon: <MdInventory className="text-4xl" />,
            route: '/billing/batches',
            color: 'from-orange-500 to-orange-600',
        },
        {
            id: 'service-payments',
            name: 'Pagamentos de Serviços',
            description:
                'Gerencie pagamentos particulares, convênios e coparticipações',
            icon: <MdAttachMoney className="text-4xl" />,
            route: '/billing/payments',
            color: 'from-teal-500 to-teal-600',
        },
        {
            id: 'coparticipation',
            name: 'Regras de Coparticipação',
            description:
                'Configure regras de coparticipação por tipo de procedimento e convênio',
            icon: <MdAttachMoney className="text-4xl" />,
            route: '/billing/coparticipation',
            color: 'from-cyan-500 to-cyan-600',
        },
    ]

    return (
        <div className="flex flex-col gap-6 p-4">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-secondary to-secondary/70 flex items-center justify-center shadow-lg">
                        <MdReceipt className="text-2xl text-white" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-base-content">
                            Faturamento
                        </h1>
                        <p className="text-sm text-base-content/60">
                            Gerencie faturamento de convênios e pagamentos
                        </p>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {billingCards.map(card => (
                    <div
                        key={card.id}
                        onClick={() => navigate(card.route)}
                        className="group cursor-pointer bg-base-100 rounded-xl border border-base-300/50 overflow-hidden hover:shadow-lg transition-all duration-300"
                    >
                        <div
                            className={`bg-gradient-to-br ${card.color} p-6 text-white`}
                        >
                            <div className="flex items-center justify-between">
                                {card.icon}
                            </div>
                        </div>
                        <div className="p-4">
                            <h3 className="text-lg font-bold text-base-content mb-2">
                                {card.name}
                            </h3>
                            <p className="text-sm text-base-content/70 mb-4 line-clamp-2">
                                {card.description}
                            </p>
                            <div className="flex items-center justify-between">
                                <span className="text-xs text-base-content/50">
                                    Clique para acessar
                                </span>
                                <MdArrowForward className="text-xl text-secondary group-hover:translate-x-1 transition-transform" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
